<template>
  <section>
    <the-title title=" my blog" backTitle="knowledge"></the-title>
  </section>
</template>


<style lang="scss" scoped>
  section{
    min-height: 100vh;
  }
</style>